/* eslint-disable no-else-return */
/* eslint-disable no-useless-return */
/* eslint-disable no-param-reassign */
import { APP_AUTH_ACCESS_KEY, APP_AUTH_REFRESH_KEY, BASE_API_URL } from '@app/constant/constant'
import axios from 'axios'
import { toast } from 'react-toastify'
import { appLogout } from '@app/utils/auth'
import { getLocal, setLocal } from '@app/utils/storage-available'

interface RefreshFn {
  originalRequest: any
  refresh_token: string
}

export const axiosInstance = axios.create({
  baseURL: BASE_API_URL,
  headers: {
    'Content-Type': 'application/json', 
    'ngrok-skip-browser-warning': 'true'
  }
})

let isAlreadyFetchingAccessToken = false

const commonRefreshFn = async ({ originalRequest, refresh_token }: RefreshFn) => {
  if (!isAlreadyFetchingAccessToken) {
    isAlreadyFetchingAccessToken = true

    const response = await axiosInstance.post('/auth/refresh', {
      refresh_token
    })

    if (response?.data) {
      isAlreadyFetchingAccessToken = false
      appLogout()
      setLocal(APP_AUTH_ACCESS_KEY, response?.data?.data?.access_token)
      setLocal(APP_AUTH_REFRESH_KEY, response?.data?.data?.refresh_token)
    } else {
      isAlreadyFetchingAccessToken = false
      appLogout()
      if (window.location.pathname === '/login') {
        return
      } else {
        setTimeout(() => {
          window.location.href = '/'
        }, 500)
      }
    }
  }
}

// Request interceptor (optional)
axiosInstance.interceptors.request.use(
  (config) => {
    const token = getLocal(APP_AUTH_ACCESS_KEY)
    const refresh_token = getLocal(APP_AUTH_REFRESH_KEY)

    if (!token && refresh_token) {
      commonRefreshFn({ originalRequest: config, refresh_token })
    }

    if (token) {
      config.headers.Authorization = `${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Response interceptor
axiosInstance.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    const { config, response } = error
    const originalRequest = config
    if (response?.data?.statusCode === 401) {
      const refresh_token = getLocal(APP_AUTH_REFRESH_KEY)
      if (refresh_token) {
        return commonRefreshFn({ originalRequest, refresh_token })
      } else {
        toast.error(error?.response?.data?.message || 'something went wrong')
        appLogout()
        window.location.href = '/login'
      }
    } else if (response?.data?.statusCode === 403) {
      toast.error(error?.response?.data?.message || 'something went wrong')
      appLogout()
      window.location.href = '/login'
    } else {
      return Promise.reject(error)
    }
    return Promise.reject(error)
  }
)
